// Typed wrappers for /api/v2/admin/dashboard and the recent-trades read used
// by the admin home screen. Backend wire shapes come from the generated
// OpenAPI schema — never hand-roll them here. See R16-A3.
import { apiClient } from "@/lib/api/client";
import type { components } from "@generated/api/schema";

export type AdminDashboardSnapshot =
  components["schemas"]["AdminDashboardResponse"];
export type AdminTradeRow = components["schemas"]["AdminTradeItemResponse"];
export type AdminTradeListPage =
  components["schemas"]["AdminTradeListResponse"];
export type AdminTopPlayersPage = components["schemas"]["TopPlayersResponse"];
export type AdminTopPlayer = components["schemas"]["TopPlayerResponse"];

export interface RecentTradesQueryParams {
  limit?: number;
}

export async function fetchAdminDashboard(): Promise<AdminDashboardSnapshot> {
  const { data, error } = await apiClient.GET("/api/v2/admin/dashboard");
  if (error || !data) {
    throw new Error(`fetchAdminDashboard failed: ${JSON.stringify(error)}`);
  }
  return data;
}

export async function fetchAdminRecentTrades(
  params: RecentTradesQueryParams = {},
): Promise<AdminTradeListPage> {
  const limit = params.limit ?? 10;
  const { data, error } = await apiClient.GET("/api/v2/admin/trades", {
    params: { query: { limit, offset: 0 } },
  });
  if (error || !data) {
    throw new Error(
      `fetchAdminRecentTrades failed limit=${limit}: ${JSON.stringify(error)}`,
    );
  }
  return data;
}

export async function fetchAdminTopPlayers(): Promise<AdminTopPlayersPage> {
  const { data, error } = await apiClient.GET("/api/v2/admin/top-players");
  if (error || !data) {
    throw new Error(`fetchAdminTopPlayers failed: ${JSON.stringify(error)}`);
  }
  return data;
}
